// extracted by mini-css-extract-plugin
export default {"sources":"sources__sources___[chunkhash-base64-5]"};